import { render, staticRenderFns } from "./CarregarControle.vue?vue&type=template&id=6f6f08ab&scoped=true&"
import script from "./CarregarControle.vue?vue&type=script&lang=js&"
export * from "./CarregarControle.vue?vue&type=script&lang=js&"
import style0 from "./CarregarControle.vue?vue&type=style&index=0&id=6f6f08ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f08ab",
  null
  
)

export default component.exports